import React from 'react';
import styled from 'styled-components';

const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
`;

const PageButton = styled.button<{ active?: boolean }>`
  background-color: ${({ active }) => (active ? '#ff6f61' : '#fff')};
  color: ${({ active }) => (active ? '#fff' : '#ff6f61')};
  border: 1px solid #ff6f61;
  padding: 8px 12px;
  margin: 0 5px;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.3s, color 0.3s;
  &:hover {
    background-color: #ff6f61;
    color: #fff;
  }
  &:disabled {
    background-color: #ddd;
    color: #aaa;
    cursor: not-allowed;
  }
`;

interface PaginationProps {
    itemsPerPage: number;
    totalItems: number;
    paginate: (pageNumber: number) => void;
    currentPage: number;
}

const Pagination: React.FC<PaginationProps> = ({ itemsPerPage, totalItems, paginate, currentPage }) => {
    const pageNumbers = [];

    for (let i = 1; i <= Math.ceil(totalItems / itemsPerPage); i++) {
        pageNumbers.push(i);
    }

    return (
        <PaginationWrapper>
            <PageButton onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                Previous
            </PageButton>
            {pageNumbers.map((number) => (
                <PageButton key={number} onClick={() => paginate(number)} active={number === currentPage}>
                    {number}
                </PageButton>
            ))}
            <PageButton onClick={() => paginate(currentPage + 1)} disabled={currentPage === pageNumbers.length}>
                Next
            </PageButton>
        </PaginationWrapper>
    );
};

export default Pagination; 